import { isPreviewAccount } from "@/utils/previewAccount";

// Envolve uma função de serviço real: na conta Preview, retorna dados
// mockados sem chamar a API; caso contrário, chama a função real normalmente.
// `mockFn` usa `any[]` (em vez de `Args`) de propósito: se ambos os
// parâmetros participassem da inferência de `Args`, o TypeScript acabava
// inferindo a assinatura mais curta (a do mock) em vez da assinatura real,
// quebrando as chamadas existentes que passam mais argumentos.
export function mockGuard<Args extends any[], T>(
  realFn: (...args: Args) => Promise<T>,
  mockFn: (...args: any[]) => T,
): (...args: Args) => Promise<T> {
  return async (...args: Args) => {
    if (isPreviewAccount()) {
      return mockFn(...args);
    }
    return realFn(...args);
  };
}
